import React from 'react';
import InstagramIcon from '@material-ui/icons/Instagram';
import { FruitPropsType } from 'src/views/harvesting/fruit-profile/model';
import FacebookIcon from '@material-ui/icons/Facebook';
import PublicIcon from '@material-ui/icons/Public';


interface PlatformIconType {
   fruit: FruitPropsType 
}

export const PlatformIcon:React.VFC<PlatformIconType> =({ fruit }) =>{
  if (fruit) {
    if (fruit.platform === 'Facebook') {
      return (
        <FacebookIcon
          style={{
            fontSize: 17,
            marginLeft: 4,
            color: '#4267B2',
          }}
        />
      );
    }
    if (fruit.platform === 'Instagram') {
      return (
        <InstagramIcon
          style={{
            fontSize: 17,
            marginLeft: 4,
            color: ' #C13584',
          }}
        />
      );
    }
    if (fruit.platform === 'Other') {
      return (
        <PublicIcon
          style={{
            fontSize: 17,
            marginLeft: 4,
            color: 'black',
          }}
        />
      );
    }
  } else {
    return <></>;
  }
  return <></>;
};
  
  